import { connect } from 'react-redux'
import {
  setPickupPersonFormField,
  setPickupPersonForm
} from 'actions/account/pickupPeople'

const mapStateToProps = ({ pickupPeople: { form } }) => ({ form })

const actions = {
  setPickupPersonFormField,
  setPickupPersonForm
}

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
